import { render, staticRenderFns } from "./SearchProductResultItem.vue?vue&type=template&id=e7fa3df4&scoped=true&"
import script from "./SearchProductResultItem.vue?vue&type=script&lang=js&"
export * from "./SearchProductResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductResultItem.vue?vue&type=style&index=0&id=e7fa3df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7fa3df4",
  null
  
)

export default component.exports